const CappedArrayPlugin = {
  install(Vue) {
    const applyCap = (array, limit) => {
      if (array.length > limit) {
        array.splice(0, array.length - limit);
      }
    };

    Vue.prototype.$pushToCappedArray = (array, limit, ...items) => {
      array.push(...items);
      applyCap(array, limit);
    };

    Vue.prototype.$concatToCappedArray = (array, limit, newItems) => {
      array.push(...newItems);
      applyCap(array, limit);
    };

    Vue.prototype.$batchCappedArray = (array, batchSize) => {
      return array.splice(0, batchSize); 
    };

    Vue.prototype.$restoreToCappedArray = (array, limit, failedBatch) => {
      array.unshift(...failedBatch); 
      applyCap(array, limit);
    };
  }
};
export default CappedArrayPlugin;

